module.exports = __webpack_public_path__ + "static/media/Hugo.737a7554.png";